import { Base64Encode } from "./Base64Encode"

/**
 * Encodes a Uint8Array to a URL-safe Base64 string.
 * Replaces + with -, / with _, and removes padding (=).
 * Safe for use in URLs and filenames.
 *
 * @param data - Bytes to encode
 * @returns URL-safe Base64 encoded string (no padding)
 *
 * @example
 * ```ts
 * import { Base64URLEncode } from "@pdfking/tfunc"
 *
 * Base64URLEncode(new TextEncoder().encode("Hello World")) // "SGVsbG8gV29ybGQ"
 * // Safe to use in URLs: /api/data?token=SGVsbG8gV29ybGQ
 * ```
 */
export const Base64URLEncode = (data: Uint8Array): string => {
  const base64 = Base64Encode(data)
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "")
}
